module.exports = __webpack_public_path__ + "static/hero-fb113a62b44b462606ddd558f6502c56.png";